import React from 'react';
import StorefrontIcon from '@mui/icons-material/Storefront';

function WelcomeModal({ isOpen, onClose, onNavigate }) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl p-8 max-w-md mx-4 relative shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-[#04a5b4] rounded-full flex items-center justify-center">
            <StorefrontIcon style={{ fontSize: '48px', color: 'white' }} />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-800">
          Welcome to 01POS!
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-8 leading-relaxed">
          To get started, you need to set up your store first by adding at least one category and subcategory.
        </p>

        {/* Button */}
        <button
          onClick={onNavigate}
          className="w-full bg-[#04a5b4] hover:bg-[#038090] text-white py-4 px-6 rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Go to My Store
        </button>

        {/* Skip link */}
        <button
          onClick={onClose}
          className="w-full mt-4 text-gray-500 hover:text-gray-700 text-sm transition-colors"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}

export default WelcomeModal;